module.exports = __webpack_public_path__ + "static/media/logoAller.ad2f0fab.png";